module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-caller"
  }, [_c('user-caller-typeahead', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEdit && !_vm.caller.id),
      expression: "!isEdit && !caller.id"
    }]
  }), _vm._v(" "), _c('cc-user-caller-form'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.caller.id),
      expression: "caller.id"
    }]
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "1px solid #CCC"
    }
  }, [(_vm.caller.info) ? _c('h4', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v(_vm._s(_vm.getInfoText))]) : _c('div', {
    staticStyle: {
      "padding-top": "57px"
    }
  }), _vm._v(" "), _c('h2', [_c('i', {
    staticClass: "fa fa-phone",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.sexText)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.UserConf.getPertitel(_vm.caller.idPertitel)))]), _vm._v("\n         " + _vm._s(_vm.caller.firstName) + " " + _vm._s(_vm.caller.lastName) + " \n         "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.caller.customerNumber),
      expression: "caller.customerNumber"
    }]
  }, [_vm._v(" (KdNr: " + _vm._s(_vm.caller.customerNumber) + ")")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.caller.street))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.caller.streetNumber) + ",")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.caller.zipCode))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.caller.city))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCallerCompanySameAsClientCompany),
      expression: "isCallerCompanySameAsClientCompany"
    }],
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClickIsClientCompany
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "title": "Mitarbeiter"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClickEdit
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "title": "Anrufer bearbeiten"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClickClone
    }
  }, [_c('i', {
    staticClass: "fa fa-clone",
    attrs: {
      "title": "Anrufer kopieren"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClickCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-eye-slash",
    attrs: {
      "title": "neu suchen"
    }
  })])])])]), _vm._v(" "), _c('div'), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.caller.company.name),
      expression: "caller.company.name"
    }]
  }, [_c('i', {
    staticClass: "fa fa-industry",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Fa: " + _vm._s(_vm.caller.company.name))]), _vm._v("\n         - "), _c('small', [_vm._v(_vm._s(_vm.caller.company.street))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.caller.company.streetNumber) + ",")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.caller.company.zipCode))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.caller.company.city))])]), _vm._v(" "), _c('div', {
    staticClass: "cc-kombox-items"
  }, [_vm._l((_vm.caller.komboxes), function(kombox) {
    return _c('cc-kombox-usercaller', {
      key: kombox.id,
      staticClass: "cc-kombox-item",
      attrs: {
        "kombox": kombox
      },
      on: {
        "remove": _vm.onRemoveKombox,
        "update": _vm.onSetKombox,
        "add-shipping": _vm.onKomboxAddShipping,
        "remove-shipping": _vm.onKomboxRemoveShipping
      }
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.caller.komboxes.length),
      expression: "!caller.komboxes.length"
    }],
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Keine Kontaktdaten hinterlegt")])], 2), _vm._v(" "), (_vm.caller.id > 0) ? _c('cc-kombox-usercaller', {
    staticClass: "cc-kombox-item",
    attrs: {
      "idCompany": 0,
      "idUser": _vm.caller.id
    },
    on: {
      "insert": _vm.onAddKombox
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.caller.company.komboxes), function(kombox) {
    return (!_vm.isCallerCompanySameAsClientCompany) ? _c('cc-kombox-usercallercolleague', {
      staticClass: "cc-kombox-item",
      attrs: {
        "kombox": kombox
      },
      on: {
        "add-shipping": _vm.onKomboxAddShipping,
        "remove-shipping": _vm.onKomboxRemoveShipping
      }
    }) : _vm._e()
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b5d0844e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/UserCaller.vue
// module id = 287
// module chunks = 0